<template>
    <NuxtLayout name="main-big" :dark="true" :favorite="true">
        <div class="module-container container">
            <div class="module-name font-variable font-bold color-1">{{ $t("CancerBiomarkersLibrary") }}</div>
            <div class="module-descript color-1">{{ $t("CancerBiomarkersLibraryDesc") }}</div>

            <diagram class="module-diagram" v-bind="binds.diagram" @advanced="methods.advanced">
                <template #name="{ data }">
                    <div class="module-names">
                        <div class="module-name" v-for="(value, key) in data.genes">
                            <template v-if="!value.id">{{ value.name || "--" }}</template>
                            <ProjectRoute v-else :class="css_normalize.assets" :to="{ name: 'Gene', params: { id: value.id } }" target="_blank">
                                {{ value.name }}
                            </ProjectRoute>
                            <div v-if="key != data.genes.length - 1" class="module-division"></div>
                        </div>
                    </div>
                </template>

                <template #source="{ data }">
                    <div class="module-sources">
                        <template v-for="(value, key) in data.sources">
                            <div v-if="!value.link">{{ value.name || "--" }}</div>
                            <ProjectRoute v-else :to="value.link" target="_blank"> {{ value.name }} <ui-icon name="export" /> </ProjectRoute>
                        </template>
                    </div>
                </template>

                <template #relevance="{ data }">
                    <div class="module-tag" :class="data.relevance_key">{{ data.relevance }}</div>
                </template>
            </diagram>
        </div>
    </NuxtLayout>
</template>

<script lang="ts" setup>
//* 组件库
import { UiIcon } from "various-ui";
//* 公共组件
import { Diagram } from "@/components/visualizations";
//* 组件属性
import { useComposable } from "./src/composable";
//* 样式
import css_normalize from "@/assets/style/src/index.module.less";

//* 组合函数
const { binds, methods } = useComposable();
//* 组件挂载后初始化数据
onMounted(() => {
    methods.init();
});
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
